module.exports = __webpack_public_path__ + "img/completed-task.06e64f93.png";